/* @flow */
import React from 'react';
import ReactDOM from 'react-dom';

import AuthActions from 'auth/AuthActions';
import BoxTitle from 'components/BoxTitle.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Device from 'entities/Device';
import Field from 'components/Field.jsx';
import Input from 'components/Input.jsx';
import Link from 'components/Link.jsx';
import ToastActions from 'actions/ToastActions';

import 'styles/utilities.scss';

const ConfirmPhone = React.createClass({
  propTypes: {
    uid: React.PropTypes.string.isRequired,
    onGoBack: React.PropTypes.func,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      isValidCode: false,
      verifying: false,
    };
  },

  componentDidMount() {
    this.sendSMSConf();
  },

  _outboundToken: null,

  // typecheck: ignore statement
  onCodeChange(event: SyntheticEvent) {
    // $FlowFixMe
    const isValidCode = event.target.value.match(/^\d{4}$/);
    this.setState({ isValidCode });
  },

  onContinue() {
    this.setState({ verifying: true });
    const onError = () => {
      this.setState({ verifying: false });
      ToastActions.showErrorToast('Error verifying your phone.');
    };
    const onSuccess = ({ token }) => {
      AuthActions.accessTokenSignIn(token)
        .then(() => this.context.router.push('/join/role_picker'))
        .catch(e => console.error('Sign in failed', e));
    };

    const code = ReactDOM.findDOMNode(this.refs.code).value;
    // $FlowFixMe
    return Device.createOutboundDevice(this._outboundToken, code).then(onSuccess, onError);
  },

  sendSMSConf(onSuccess?: Function, onError?: Function) {
    return Device.outboundVerify(this.props.uid)
      .then(({ token }) => {
        this._outboundToken = token;
        if (onSuccess) {
          onSuccess();
        }
      }, onError);
  },

  resendSMSConf() {
    const onError = () => ToastActions.showErrorToast('Error sending the code');
    const onSuccess = () => ToastActions.showSuccessToast('Code successfully resent');
    return this.sendSMSConf(onSuccess, onError);
  },

  render() {
    return (
      <div className="ConfirmPhone">
        <BoxTitle>Enter your code</BoxTitle>
        <p className="block">
          Please enter the 4-digit code sent to you.
          <br />
          Didn’t receive the code?
          {' '}
          <Link onClick={this.resendSMSConf}>Resend</Link>
        </p>
        <Field>
          <Input
            ref="code"
            autofocus
            placeholder="0000"
            maxLength="4"
            onChange={this.onCodeChange}
            size="large"
          />
        </Field>
        <Buttons axis="y">
          <Button
            disabled={!this.state.isValidCode || this.state.verifying}
            onClick={this.onContinue}
            full>
            Continue
          </Button>
          <Button
            level="text"
            onClick={this.props.onGoBack}>
            Go back
          </Button>
        </Buttons>
      </div>
    );
  },
});

export default ConfirmPhone;



// WEBPACK FOOTER //
// ./src/auth/components/ConfirmPhone.jsx